import React from 'react'
import { connect } from 'react-redux'
import Icon from '../icon'
import List from '../list'
import Image from '../image'
import Text from '../text'
import StatusPlaceholder from '../placeholder/status_placeholder'
import TabBar from '../tab_bar'

class GroupPreview extends React.PureComponent {
  
  render() {
    const {
      titleValue,
      passwordValue,
      descriptionValue,
      coverImage,
      isSubmitting,
      idValue,
      category,
      isPrivate,
      isVisible,
      isAdminsVisible,
      isMediaVisible,
      isLinksVisible,
      isMembersVisible,
      isModerated,
      categories,
      allowQuotes,
    } = this.props
    
    const visibilityBlock = {
      icon: isVisible ? 'globe' : 'lock-filled',
      title: isVisible ? 'Visible' : 'Hidden',
      subtitle: isVisible ? 'Anyone can find this group.' : 'Only members can find this group.',
    }

    const privacyBlock = {
      icon: isPrivate ? 'lock-filled' : 'globe',
      title: isPrivate ? 'Private' : 'Public',
      subtitle: isPrivate ? 'Only members can see posts made in this group.' : 'Anyone can see posts made in this group.',
    }

    const title = titleValue || 'Group name'

    const tabs = [
      { title: 'Timeline', active: true },
      { title: 'Featured' },
      { title: 'About' },
      { title: 'Media' },
      { title: 'Members' },
    ]

    const listItems = [
      {
        title: privacyBlock.title,
        icon: privacyBlock.icon,
        subtitle: privacyBlock.subtitle,
        iconSize: '16px',
      },
      {
        title: visibilityBlock.title,
        icon: visibilityBlock.icon,
        subtitle: visibilityBlock.subtitle,
        iconSize: '16px',
      },
      isModerated && {
        title: 'Moderated',
        icon: 'lock-filled',
        iconSize: '16px',
        subtitle: 'Gab groups are moderated by users. This group additionally screens newer users.',
      },
      !!category && {
        title: 'Category',
        icon: 'apps',
        iconSize: '16px',
        subtitle: category.get('text'),
      },
    ].filter(Boolean)

    return (
      <div className={[_s.d, _s.calcH106PX, _s.bgPrimary, _s.w100PC, _s.maxW80PC, _s.mt15, _s.px15, _s.py15, _s.radiusSmall, _s.overflowHidden, _s.boxShadowModal, _s.mlAuto, _s.mrAuto].join(' ')}>

        <Text weight='bold' className={_s.mb15}>Preview</Text>
        <div className={[_s.d, _s.flex1, _s.bgPrimary, _s.radiusSmall, _s.overflowYScroll, _s.border1PX, _s.borderColorSecondary].join(' ')}>
          <div className={[_s.d, _s.cursorNotAllowed, _s.posAbs, _s.top0, _s.left0, _s.right0, _s.bottom0, _s.z2].join(' ')} />
          <div style={{ filter: 'opacity(0.675) grayscale(1)' }}>
            <div className={[_s.d, _s.z1, _s.w100PC].join(' ')}>
              <div className={[_s.d, _s.w100PC, _s.jcCenter, _s.borderBottom1PX, _s.borderColorSecondary, _s.boxShadowBlock].join(' ')}>
                <div className={[_s.d, _s.z3, _s.w100PC, _s.h350PX, _s.overflowHidden].join(' ')}>
                  <Image cfWidthPX='1024px' width="100%" height="100%" src={coverImage} alt='Cover image' />
                </div>
                <div className={[_s.d, _s.pt15, _s.pb5, _s.px15, _s.maxW640PX].join(' ')}>
                  <div className={_s.d}>
                    <Text size='extraExtraLarge' weight='extraBold' color='secondary'>{title}</Text>
                  </div>
                  <div className={[_s.d, _s.flexRow, _s.aiCenter, _s.mt10].join(' ')}>
                    <Icon id={privacyBlock.icon} size="12px" className={_s.cSecondary} />
                    <Text color="secondary" className={_s.ml5}>{privacyBlock.title}</Text>
                    <Text size='small' color='secondary' className={[_s.mr5, _s.ml5].join(' ')}>·</Text>
                    <Text color="secondary">1 member</Text>
                  </div>
                </div>
                <TabBar tabs={tabs} isLarge />
              </div>
            </div>
          </div>
          <div className={[_s.d, _s.pt15, _s.px15, _s.flexRow, _s.bgSubtle].join(' ')}>
            <div className={[_s.d, _s.flex1, _s.pr15].join(' ')}>
              <StatusPlaceholder speed={0} />
              <StatusPlaceholder speed={0} />
            </div>
            <div className={[_s.d, _s.w380PX, _s.pt5].join(' ')}>
              <div className={[_s.d, _s.bgPrimary, _s.boxShadowBlock, _s.radiusSmall, _s.px5, _s.py15].join(' ')}>
                <div className={_s.d} style={{ filter: 'opacity(0.675) grayscale(1)' }}>
                  <div className={[_s.d, _s.px10].join(' ')}>
                    <Text color="secondary" size="extraLarge" weight="bold" className={_s.pb15}>About</Text>
                    {!!descriptionValue && <Text color="secondary" className={_s.pb10}>{descriptionValue}</Text>}
                  </div>
                  {
                    listItems.map((item, i) => {
                      return (
                        <div key={`group-preview-${i}-${title}`} className={[_s.d, _s.w100PC, _s.px10, _s.mt5, _s.pb15].join(' ')}>
                          <div className={[_s.d, _s.py2].join(' ')}>
                            <div className={[_s.d, _s.flexRow, _s.aiCenter].join(' ')}>
                              <Icon id={item.icon} size='16px' className={_s.cPrimary} />
                              <Text weight='bold' size='large' className={_s.ml10}>
                                {item.title}
                              </Text>
                            </div>
                            <div className={[_s.d, _s.mt5, _s.pl25].join(' ')}>
                              <Text color='secondary'>{item.subtitle}</Text>
                            </div>  
                          </div>
                        </div>
                      )
                    })
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, props) => {
  const categoryId = state.getIn(['group_editor', 'category'])
  const categories = state.getIn(['group_categories', 'items'])
  const category = !!categories ? categories.find((c) => c.get('id') === categoryId) : null

  return {
    titleValue: state.getIn(['group_editor', 'title']),
		passwordValue: state.getIn(['group_editor', 'password']),
		descriptionValue: state.getIn(['group_editor', 'description']),
		coverImage: state.getIn(['group_editor', 'coverImage']),
		isSubmitting: state.getIn(['group_editor', 'isSubmitting']),
		idValue: state.getIn(['group_editor', 'id']),
		isPrivate: state.getIn(['group_editor', 'isPrivate']),
		isVisible: state.getIn(['group_editor', 'isVisible']),
		isAdminsVisible: state.getIn(['group_editor', 'isAdminsVisible']),
		isMediaVisible: state.getIn(['group_editor', 'isMediaVisible']),
		isLinksVisible: state.getIn(['group_editor', 'isLinksVisible']),
		isMembersVisible: state.getIn(['group_editor', 'isMembersVisible']),
		isModerated: state.getIn(['group_editor', 'isModerated']),
		category,
		allowQuotes: state.getIn(['group_editor', 'allowQuotes']),
  }
}

export default connect(mapStateToProps)(GroupPreview)